module.exports = __webpack_public_path__ + "img/holiday-empty-image.ea3f5992.png";